import { defineMessages } from 'react-intl';

export default defineMessages({
  metaDescriptionTemplate: {
    id: 'MetaTitleUtils.metaDescriptionTemplate',
    defaultMessage:
      'Get your [BRAND] [CATEGORY] trailer parts here at [SITE_TITLE].'
  }
});
